<template>
    <v-container fluid class="container-full-bg-gray">
        <v-card class="einvoice-trial-card">
            <v-card-title>
            Factura Electrónica
            </v-card-title>
            <v-card-text>
            <div class="centered-content">
                <img src="/bank_new_icon.png"/>
                <div class="primary--text font-30 pb-7">
                Factura Electrónica
                </div>
                <div class="font-weight-light pb-3">
                Descubre la facilidad de simplificar<br>
                tu facturación electrónica con nosotros. <a href="https://www.youtube.com/watch?v=vjp3oEWNNXw" target="_blank">(DEMO)</a>
                </div>
                <template >
                    <div class="font-weight-bold">Prueba Gratuita*</div>
                    <div class="pb-7 flex flex-col">
                        <small>*La prueba gratuita incluye el uso de la factura electronica en esta empresa por un máximo de 7 días.</small>
                    </div>
                    <v-btn            
                        rounded
                        color="primary"
                        :loading="screen_data.loading"
                        @click="activateEInvoiceTrial"
                        >
                        Empieza gratis
                    </v-btn>
                </template>
         
            </div>
            </v-card-text>
        </v-card>
        
        <v-snackbar
            v-model="showError"
            :timeout="6000"
            color="error"
            top
        >
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="showError = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { ApiInvoiceContractRepository } from "../modules/facturae/infra/ApiInvoiceContractRepository";
import { VueInvoiceContractScreenData } from "../modules/facturae/infra/VueInvoiceContractScreenData";
import { InvoiceContractComponent } from "../modules/facturae/app/InvoiceContractComponent";
import { mapGetters } from "vuex";

export default {
    name: 'InvoiceTrial',
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        const screen_data = new VueInvoiceContractScreenData();
        return {
            screen_data,
            invoice_trial_component: null,
            showError: false,
            errorMessage: '',
        };
    },
    async mounted() {
        let invoice_contract_repo = new ApiInvoiceContractRepository();
        this.invoice_trial_component = new InvoiceContractComponent(invoice_contract_repo, this.screen_data);
        this.invoice_trial_component.checkEInvoiceContractShowTrial(this.companydb_id);
    },
    methods: {
        async activateEInvoiceTrial() {
            let response = await this.invoice_trial_component.activateEInvoiceTrialContract(this.companydb_id);

            const output = response && response.output ? response.output : {};
            const status = output.status;
            const data = output.data;
            const error = output.error;
            const message = output.message;

            if (status === 200 && data === 'ok') {
                this.$router.replace(
                    { name: 'invoice-list', params: { companydb_id: this.companydb_id } },
                    () => this.$router.go(0)
                );
            } else {
                this.handleError(output);
            }
        },

        handleError(output) {
            const errorMessages = {
                'UserIsNotClient': 'Tu usuario no es un cliente. Contacta con tu asesor.',
                'FeatureNotEnabled': 'Esta funcionalidad no está activada para tu usuario. Contacta con tu asesor.',
                'OwnerNotFound': 'No se encontró tu asesor. Contacta con soporte.',
                'CompanyNotFound': 'Empresa no encontrada.',
                'CompanyPermissionDenied': 'No tienes permisos para activar el trial en esta empresa.',
                'ServiceNotFound': 'Servicio no disponible. Contacta con soporte.',
                'ContractAlreadyExists': 'Ya tienes un contrato activo de facturación electrónica.',
                'ClientMustHaveExactlyOneCompany': 'Solo puedes tener una empresa para activar el trial.',
                'InternalError': 'Error interno del sistema. Por favor, inténtalo más tarde.',
                'NetworkError': 'Error de conexión con el servidor. Por favor, inténtalo más tarde.',
            };

            const errorCode = output.error || 'InternalError';
            const defaultMessage = output.message || 'Ha habido un error al crear el contrato trial';
            this.errorMessage = errorMessages[errorCode] || defaultMessage;
            this.showError = true;
        }
    },
    computed: {
        ...mapGetters({
            userData: 'me/userData',
            permission: 'permissions/permission',
            got_feature: 'got_feature',
        }),
    },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px;
}
.einvoice-trial-card {
  height: 99%;
  min-height: 480px;
  border-radius: 12px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.einvoice-trial-card .v-card__title {
  color: var(--v-primary-base);
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 30px;
}

.einvoice-trial-card .centered-content {
  text-align: center;
  width: 98%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>